import { useEffect, useMemo, useState } from 'react';
import API from '../../../Utils/api';
import Table from '../../../Components/Table/Table';
import { useNavigate } from 'react-router';
import Avatar from 'react-avatar';

import styles from './UserSearchPage.module.css';
import Modal from '../../../Components/Modal/Modal';
import InviteUserModal from './InviteUserModal';

import { toast } from 'react-toastify';

export default function UserSearchPage() {
    const [users, setUsers] = useState(null);
    const [inviteUserModal, setInviteUserModal] = useState(null);

    const [search, setSearch] = useState('');

    const switchAccountStatus = async (e, user) => {
        e.stopPropagation();
        try {
            const foundUser = users.find(u => u._id === user._id);
            if (user.status === 'Active') {
                await API.deActivateAccount(user._id);
                foundUser.status = 'Inactive';
            } else {
                await API.activateAccount(user._id);
                foundUser.status = 'Active';
            }
            setUsers([...users]);
            toast.success('User was successfully updated!', {
                position: 'bottom-center'
            });
        } catch (error) {
            toast.error(error?.response?.data?.error, {
                position: 'bottom-center'
            });
        }
    };

    const usersColumns = [
        {
            Header: 'User',
            accessor: r => `${r.firstName} ${r.lastName}`,
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Avatar
                        name={`${row.original.firstName} ${row.original.lastName}`}
                        size='40'
                        round={true}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontWeight: '500', color: 'var(--color-text-primary)' }}>
                            {row.original.firstName} {row.original.lastName}
                        </span>
                        <span style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>
                            {row.original.email}
                        </span>
                    </div>
                </div>
            )
        },
        {
            id: 'userType',
            Header: () => <div style={{ textAlign: 'center' }}>User Type</div>,
            accessor: 'type',
            Cell: ({ value }) => (
                <div style={{ textAlign: 'center' }}>{value}</div>
            )
        },
        {
            id: 'accountStatus',
            Header: () => <div style={{ textAlign: 'center' }}>Account Status</div>,
            accessor: 'status',
            Cell: ({ value, row }) => (
                <div onClick={e => switchAccountStatus(e, row.original)} style={{ textAlign: 'center', cursor: 'pointer' }}>{value}</div>
            )
        }
    ];

    const navigate = useNavigate();

    const fetchAndSetData = async () => {
        const { data } = await API.getAllUsers();

        setUsers(data);
    };

    useEffect(() => {
        fetchAndSetData();
    }, []);

    const usersToShow = useMemo(() => {
        if (!users) return [];
        const _search = search.toLowerCase();
        return users.filter(
            u =>
                u.firstName?.toLowerCase().startsWith(_search) ||
                u.lastName?.toLowerCase().startsWith(_search) ||
                u.email?.toLowerCase().startsWith(_search) ||
                u.type?.toLowerCase().startsWith(_search)
        );
    }, [search, users]);

    const onUserClick = userClicked => {
        if (userClicked.type === 'Coach') {
            navigate(`/coach/${userClicked._id}`);
        } else if (userClicked.type === 'Athlete') {
            navigate(`/athlete/${userClicked._id}`);
        }
    };

    if (!users) return null;

    const createUserInviteModal = () => {
        if (!inviteUserModal) return null;

        return (
            <Modal
                closeCB={() => setInviteUserModal(false)}
                title={'Invite User'}
                children={
                    <InviteUserModal
                        onClose={newUser => {
                            setUsers([newUser, ...users]);
                            setInviteUserModal(false);
                        }}
                    />
                }
            />
        );
    };

    return (
        <div className={styles.pageWrap}>
            <div className={styles.top}>
                <h3>Users</h3>
                <div className='btn btn-primary' onClick={() => setInviteUserModal(true)}>
                    Add User
                </div>
            </div>
            <input
                type='search'
                onChange={u => setSearch(u.target.value)}
                placeholder='Search...'
                className='island'
                style={{ border: 0, padding: '5px' }}
            ></input>
            <div className={`${styles.userTableWrap} island`}>
                <Table columns={usersColumns} data={usersToShow} onRowClick={onUserClick} />
            </div>
            {createUserInviteModal()}
        </div>
    );
}
